import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { gtagReportConversion } from "@/lib/gtag";
import { safeColor, useCopyOverride, usePromoActive } from "@/lib/copyOverrides";
import { sendPromoEvent } from "@/lib/promoEvents";
import { useBannerHidden } from "@/lib/bannerVisibility";

const viewed = new Set<string>();

export function PromoBanner() {
  const bannerHidden = useBannerHidden();
  const location = useLocation();
  const navigate = useNavigate();

  const active = usePromoActive("banner");
  const desktopText = useCopyOverride("banner.desktop");
  const mobileText = useCopyOverride("banner.mobile");
  const href = useCopyOverride("banner.href");
  const bg = safeColor(useCopyOverride("banner.bg"));
  const fg = safeColor(useCopyOverride("banner.fg"));


  const isBookingPage = location.pathname.startsWith("/book-now");
  const rendered = !isBookingPage && active;

  useEffect(() => {
    if (!rendered) return;
    if (viewed.has(location.pathname)) return;
    viewed.add(location.pathname);
    sendPromoEvent("banner", "view");
  }, [rendered, location.pathname]);

  if (!rendered) return null;

  const handleClick = () => {
    gtagReportConversion();
    sendPromoEvent("banner", "click");
    const target = href || "/book-now";
    if (/^https?:\/\//i.test(target)) {
      window.open(target, "_blank", "noopener,noreferrer");
    } else {
      navigate(target);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{ backgroundColor: bg, color: fg }}
      className={`fixed top-0 left-0 right-0 z-50 bg-coral-orange text-white text-center py-2 px-4 text-sm md:text-base font-medium transition-all duration-300 block hover:bg-coral-orange/90 ${
        bannerHidden ? "opacity-0 pointer-events-none -translate-y-full" : "opacity-100 translate-y-0"
      }`}
    >
      <span className="md:hidden">{mobileText}</span>
      <span className="hidden md:inline">{desktopText}</span>
    </button>
  );
}
